import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Index from './components/Index';
import FAQ from './components/FAQ';
import Topics from './components/Topics';
import Cards from './components/Cards';
import App from './components/App';
import Features from './components/Features';
import Ranking from './components/Ranking';
import Media from './components/Media';
import Updates from './components/Updates';
import Carousel from './components/Carousel';
import Contact from './components/Contact';
import Comments from './components/Comments';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <About />
        <Index />
        <FAQ />
        <Topics />
        <Cards />
        <App />
        <Features />
        <Ranking />
        <Media />
        <Updates />
        <Carousel />
        <Contact />
        <Comments />
      </main>
      <Footer />
    </div>
  );
}